var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.629 13.59a1.381 1.381 0 0 0 1.964 0 1.408 1.408 0 0 0 0-1.98L13.483.41a1.381 1.381 0 0 0-1.965 0L.407 11.61a1.408 1.408 0 0 0 0 1.98 1.381 1.381 0 0 0 1.964 0L12.5 3.38l10.129 10.21Z",
    fill: "#0075C9"
  })));
};
export default SvgChevronUp;